module.exports = __webpack_public_path__ + "img/sportsteamscutout.6b07b470.jpg";